// src/pages/PrivacyPolicyLotusCab.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicyLotusCab = () => {
  return (
    <div>
      <Helmet>
        <title>Lotus Cab | Privacy Policy</title>
        <meta
          name="description"
          content="Lotus Cab Privacy Policy explaining how we collect, use, and protect your personal information when you use our cab services."
        />
        <link rel="canonical" href="https://www.lotuscab.com/privacy-policy" />
      </Helmet>

 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title">Privacy Policy</h2>
        </div>
      </div>
    </section>


      

      {/* Privacy Policy Content */}
      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At <b>Lotus Cab</b>, we respect your privacy and are committed
                to safeguarding your personal information. This Privacy Policy
                explains how we collect, use, store, and protect your data
                when you access or use our cab booking services.
              </p>

              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>

                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  When you book a ride, we may collect your name, phone number,
                  email address, pickup and drop details, payment information,
                  and other necessary travel details.
                </p>

                <p className="highlight darkcolor">2. Usage Information:</p>
                <p>
                  We collect technical information such as IP address,
                  browser type, device information, and pages visited
                  to improve website performance and user experience.
                </p>

                <p className="highlight darkcolor">3. Location Data:</p>
                <p>
                  With your consent, we may access your location data
                  to provide accurate pickup and drop services and
                  optimize travel routes.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>

                <p className="highlight darkcolor">1. Service Fulfillment:</p>
                <p>
                  Your data helps us confirm bookings, assign drivers,
                  process payments, and ensure smooth ride operations.
                </p>

                <p className="highlight darkcolor">2. Service Improvement:</p>
                <p>
                  We analyze customer feedback and usage patterns
                  to enhance safety, service quality, and operational efficiency.
                </p>

                <p className="highlight darkcolor">3. Communication:</p>
                <p>
                  We may send ride confirmations, trip updates,
                  invoices, and important notifications related to your booking.
                </p>

                <p className="highlight darkcolor">4. Marketing & Promotions:</p>
                <p>
                  With your permission, we may send promotional offers,
                  discounts, and service updates via SMS, email, or WhatsApp.
                  You can opt out anytime.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing:</p>

                <p className="highlight darkcolor">1. Trusted Partners:</p>
                <p>
                  We may share information with secure third-party partners
                  for payment processing, analytics, and customer support services.
                </p>

                <p className="highlight darkcolor">2. Legal Compliance:</p>
                <p>
                  Information may be disclosed if required by law
                  or to protect against fraud, misuse, or legal claims.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Protection:</p>
                <p>
                  Lotus Cab implements strong technical and organizational
                  measures to protect your data. However, no digital system
                  can guarantee absolute security.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You may request access, correction, or deletion of
                  your personal data. You may also unsubscribe from
                  promotional communications at any time.
                </p>

                <p className="highlight darkcolor">Policy Updates:</p>
                <p>
                  Lotus Cab reserves the right to update this Privacy Policy.
                  Any modifications will be posted on this page with
                  the revised effective date.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>
              If you have any questions regarding our Privacy Policy,
              please contact us:
            </p>
            <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+918767592195">+91 8767592195</a>
              </li>
              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@lotuscab.com">
                  booking@lotuscab.com
                </a>
              </li>
              <li>
                <b>Website:</b>{" "}
                <a
                  href="https://www.lotuscab.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.lotuscab.com
                </a>
              </li>
            </ul>
          </div>

        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyLotusCab;
